import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  urlBase = environment.urlApi;
  categories;
  fournisseurs;
  constructor(private http: HttpClient) {

  }


  allCategories()
  {
    return this.http.get(this.urlBase+"/categories");
  }
  allCategoriesByNv(nv,id)
  {
    return this.http.get(this.urlBase+"/categories?nv="+nv+"&id="+id);
  }
  allSubCategories(){
    return this.http.get(this.urlBase+"/niveau/categoriesByniveau");
  }
  getCategoriesByParentsId(f1Id,f2Id)
  {
    this.http.get(this.urlBase+"/categories").subscribe(res =>{
      this.categories = res['categories'];
      this.fournisseurs = res['fournisseurs'];
    });
  }

}
